/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    REMOVE_LIST_ENTRY,
    SET_LIST_ENTRY,
    SET_LIST_ENTRY_FOCUS,
    SET_LIST_ENTRY_LIMIT,
    SET_LIST_ENTRY_POSITION,
} from './list.types';
import { IListEntry } from './listprops';

export const setListEntry = (
    id: string,
    entry: IListEntry,
): TivoPayloadAction<{ id: string; entry: IListEntry }> => ({
    type: SET_LIST_ENTRY,
    payload: { id, entry },
});

export const removeListEntry = (id: string): TivoPayloadAction<{ id: string }> => ({
    type: REMOVE_LIST_ENTRY,
    payload: { id },
});

export const setListEntryLimit = (
    id: string,
    limit: number,
): TivoPayloadAction<{ id: string; limit: number }> => ({
    type: SET_LIST_ENTRY_LIMIT,
    payload: { id, limit },
});

export const setListEntryPosition = (
    id: string,
    position: number,
): TivoPayloadAction<{ id: string; position: number }> => ({
    type: SET_LIST_ENTRY_POSITION,
    payload: { id, position },
});

export const setListEntryFocus = (
    id: string,
    isFocused: boolean,
): TivoPayloadAction<{ id: string; isFocused: boolean }> => ({
    type: SET_LIST_ENTRY_FOCUS,
    payload: { id, isFocused },
});
